module.exports = __webpack_public_path__ + "img/side-icon-14.fc8006c7.svg";